export const PAGE_SIZE = 20;

export const BASE_URL = new URL("https://vikingfootwear.com");

export const SITE_NAME = "Viking Footwear";

export const CacheLife = {
	/**
	 * 1 Minute
	 */
	Seconds: 60,
	/**
	 * 15 Minutes
	 */
	Minutes: 60 * 15,
	/**
	 * 1 Hour
	 */
	Hours: 60 * 60,
	/**
	 * 1 Day
	 */
	Days: 60 * 60 * 24,
	/**
	 * 1 Week
	 */
	Weeks: 60 * 60 * 24 * 7,
	/**
	 * 1 Month
	 */
	Months: 60 * 60 * 24 * 30,
};

export const FILTER_SPLIT_KEY = "$$__$$";
